import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { OrganizationConfigService } from '../../../../../../../services/organization-config/organization-config.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';
import { CapitanLocation } from '../../../../../../../models/location';
import { LocationService } from '../../../../../../../services/location/location.service';


@Component({
  selector: 'app-set-lightspeed-location-map-modal',
  templateUrl: './set-lightspeed-location-map-modal.component.html',
  styleUrls: ['./set-lightspeed-location-map-modal.component.css']
})
export class SetLightspeedLocationMapModalComponent implements OnInit {
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public lightspeedLocations: {id: string, name: string}[];
  public capitanLocations: CapitanLocation[];

  public loadingLightspeedLocations = true;
  public loadingCapitanLocations = true;
  public loadingSave = false;

  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService,
    private locationService: LocationService
  ) {}

  ngOnInit() {
    this.loadLightspeedLocations();
    this.loadCapitanLocations();
  }

  public handleSubmit() {
    this.loadingSave = true;
    this.errorMessage = '';

    const locationMap = {};
    for (const capitanLocation of this.capitanLocations) {
      locationMap[capitanLocation.id] = capitanLocation.lightspeed_location_id;
    }

    this.orgConfigService
      .setLightspeedLocationMap(locationMap)
      .then(() => {
        this.savedCallback({
          text: 'Lightspeed locations updated successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSave = false; });
  }

  private loadLightspeedLocations() {
    this.loadingLightspeedLocations = true;

    this.orgConfigService
      .getLightspeedLocations()
      .then(response => {
        this.lightspeedLocations = response;
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loadingLightspeedLocations = false; });
  }

  private loadCapitanLocations() {
    this.loadingCapitanLocations = true;

    this.locationService
      .loadLocations()
      .then(() => {
        this.capitanLocations = this.locationService.getLocations();
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loadingCapitanLocations = false; });
  }

}
